import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { ErrorResponse } from "types";

import { accountStatusUpdate } from "../apis/AccountStatusUpdate";

const useUpdateAccountStatusMutation = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: accountStatusUpdate,
    mutationKey: [QUERY_KEYS.change_account_status],
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: [QUERY_KEYS.accounts_listing] });
    },
    onError: (error: ErrorResponse) => errorModal(error)
  });
  return mutation;
};
export default useUpdateAccountStatusMutation;
